import 'client/javascript/main';
import { setupProductCards } from 'client/javascript/pages/building/product_cards';
import BuildingForm from 'client/javascript/pages/building/form';
import { loadBuildingMap } from 'client/javascript/pages/building/building_map';
import ShareButton from 'client/javascript/pages/building/share_button';
import SelfServe from 'client/javascript/pages/building/self_serve';
import { addReviewsListeners } from 'client/javascript/pages/building/reviews';

// SHARED
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { triggerDataLayer, trackInteraction } from 'client/javascript/analytics';
import { fetchGeoData } from 'client/javascript/geo';
import { setupAmenitiesOverlay } from 'client/javascript/amenities_overlay';
import { sendBuildingReviewsBucketEvent } from 'client/javascript/heap';
import SaveButton from 'client/javascript/save_button';
import NearbyBuildings from 'client/javascript/nearby_buildings';
import CollapsePanel from 'client/shared/collapse_panel';
import PictureTooltip from 'client/shared/picture_tooltip';
import { setupBuildingsAnalytics, setupBuildingPagePDPExperiment } from './analytics';
import { setupSliders } from './sliders';
import { setupMarketingAssets } from './marketing_assets';

fetchGeoData();

const buildingForm = new BuildingForm();
const selfServe = new SelfServe();
const shareButton = new ShareButton();
let nearbyBuildings;

const { showSelfServe } = varsFromServer.experiments;

onContentLoaded(() => {
  onPolyfillsLoaded(() => {
    nearbyBuildings = NearbyBuildings.create({ trackEventLabel: 'Building Page - Click - Nearby Building' });
    setupProductCards(nearbyBuildings, showSelfServe, selfServe);
    loadBuildingMap();
    shareButton.setUpShareButtonEvents();
    CollapsePanel.setUp();
    PictureTooltip.setUp();
    if (showSelfServe) {
      selfServe.setupSelfServe();
    }
    buildingForm.setupFirstLeadForm();
    buildingForm.setUpLeadFormButtonMobile();
    pushToDataLayer();
    if (!varsFromServer.showStaticImage) {
      setupSliders();
    }
    setupAmenitiesOverlay();
    addTrackingHandlers();
    addReviewsListeners();

    // eslint-disable-next-line no-new
    new SaveButton(varsFromServer.building.id, '#filled-heart-icon', '#empty-heart-icon');

    setUpTests();
    setupMarketingAssets();
    const descriptionContainer = document.querySelector('.building-info');
    descriptionContainer.addEventListener('click', setUpReadMoreListener);
    setupBuildingPagePDPExperiment();
  });
});

function setUpReadMoreListener(e) {
  if (e.target.closest('.read-more-cta')) {
    const element = e.target;
    const parent = element.parentElement;
    const reviewContainer = parent.closest('.description-container');
    const originalText = reviewContainer.querySelector('.hiddent-text-content');

    originalText.classList.remove('hiddent-text');
    originalText.classList.remove('hiddent-text-content');
    parent.classList.add('hiddent-text-content');
  }
}

function pushToDataLayer() {
  const event = {
    event: 'Building Data',
    market_uuid: varsFromServer.market.id,
    building_uuid: varsFromServer.building.id
  };

  triggerDataLayer([event]);
}

function addTrackingHandlers() {
  bindTrackInteractionHandler('signup-link', {
    label: 'V2 building page product card sign up link'
  });

  bindTrackInteractionHandler('virtual-tour', {
    label: 'virtual tour button'
  });
}

function bindTrackInteractionHandler(elementId, trackingProps) {
  const el = document.getElementById(elementId);
  if (el) {
    el.addEventListener('click', () => {
      trackInteraction(trackingProps);
    });
  }
}

function setUpTests() {
  const ratingLink = document.querySelector('.rating__link');

  // GLOBALYZER_START_IGNORE
  if (ratingLink) {
    sendBuildingReviewsBucketEvent('building reviews - enabled and showing', { triggerHotjar: true });
  } else {
    sendBuildingReviewsBucketEvent('building reviews - enabled and hiding', { triggerHotjar: true });
  }
  // GLOBALYZER_END_IGNORE

  setupBuildingsAnalytics();
}
